import { Modal, Skeleton } from 'antd';
import { useEffect, useState } from 'react';
import { apiNode } from '../../../../services/api';
import { Card as CustomCard } from './components/Card';
import { CustomButton, Content, ModalContainer } from './styles';

interface LeagueProps {
  id: number;
  nome: string;
  privada: boolean;
  createdAt: string;
}

interface LeagueParticipants {
  id: number;
  userId: number;
  ligaId: number;
  isAdmin: boolean;
  pontos: number;
  createdAt: string;
  username: string;
  foto: string;
}

interface JoinLeagueModalProps {
  league: LeagueProps;
  isOpen: boolean;
  closeModal: () => void;
  updateHasLeague: () => Promise<void>;
}

export const JoinLeagueModal = ({
  league,
  isOpen,
  closeModal,
  updateHasLeague,
}: JoinLeagueModalProps) => {
  const [participants, setParticipants] = useState<LeagueParticipants[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isButtonLoading, setIsButtonLoading] = useState(false);

  useEffect(() => {
    const getParticipants = async () => {
      try {
        setIsLoading(true);
        if (league.id) {
          const response = await apiNode.get(`/ligas/${league.id}`);
          setParticipants(response.data.liga.participantes_ligas);
        }

        setIsLoading(false);
      } catch (err) {
        console.log(err);
        setIsLoading(false);
      }
    };

    getParticipants();
  }, [league.id]);

  const joinLeague = async () => {
    try {
      setIsButtonLoading(true);
      await apiNode.post('/ligas/participantes', {
        ligaId: league.id,
      });

      await updateHasLeague();
      setIsButtonLoading(false);
      closeModal();
    } catch (err) {
      setIsButtonLoading(false);
      console.log(err);
    }
  };

  const joinPrivateLeague = async () => {
    try {
      setIsButtonLoading(true);
      await apiNode.post('/ligas/solicitar', {
        ligaId: league.id,
      });

      setIsButtonLoading(false);
      closeModal();
    } catch (err) {
      setIsButtonLoading(false);
      console.log(err);
    }
  };

  return (
    <ModalContainer>
      <Modal
        visible={isOpen}
        onCancel={closeModal}
        footer={[
          <CustomButton
            type="primary"
            onClick={league.privada ? joinPrivateLeague : joinLeague}
            loading={isButtonLoading}
            disabled={isLoading}
            key="submitButton"
            style={{
              background: '#50915b',
              height: 50,
              width: '100%',
              fontSize: '1.5rem',
            }}
          >
            {league.privada ? 'Solicitar Entrada (Liga privada)' : 'Entrar'}
          </CustomButton>,
        ]}
        bodyStyle={{ padding: 0 }}
        style={{ top: 30 }}
      >
        <Content>
          <h1>{league.nome}</h1>
          <span>
            <div>
              {isLoading && (
                <>
                  <Skeleton
                    loading={isLoading}
                    avatar
                    active
                    style={{
                      marginBottom: 40,
                      width: 420,
                    }}
                    key="loading1"
                  />
                  <Skeleton
                    loading={isLoading}
                    avatar
                    active
                    style={{
                      marginBottom: 20,
                      width: 420,
                    }}
                    key="loading2"
                  />
                  <Skeleton
                    loading={isLoading}
                    avatar
                    active
                    style={{
                      marginBottom: 20,
                      width: 420,
                    }}
                    key="loading3"
                  />
                </>
              )}
              {participants &&
                !isLoading &&
                participants.map((participant) => (
                  <CustomCard key={participant.id} participant={participant} />
                ))}
            </div>
          </span>
        </Content>
      </Modal>
    </ModalContainer>
  );
};
